import * as _ from 'lodash';
import { ColumnHandler } from '../types';
import { parseJson, parseDatetime, parseString } from '../converters';
import { CountryColumnType } from '../../monday-api/api';

export type CountryColumnValue = {
  text: string | null;
  country_code: string | null;
  country_name: string | null;
  changed_at: string | null;
};

const handler: ColumnHandler<CountryColumnType, CountryColumnValue> = {
  type: 'country',

  default_value_field: 'text',

  supported_rules: [
    {
      operator: 'any_of',
      compare_value_ids: ['empty_string', 'country_short'],
    },
    {
      operator: 'not_any_of',
      compare_value_ids: ['empty_string', 'country_short'],
    },
    {
      operator: 'is_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'is_not_empty',
      compare_value_ids: ['empty_null'],
    },
    {
      operator: 'contains_text',
      compare_value_ids: ['text'],
    },
    {
      operator: 'not_contains_text',
      compare_value_ids: ['text'],
    },
  ],

  convertValueFromMondayToEngine: (columnValue) => {
    const text = parseString(columnValue.text);
    const value = parseJson(columnValue.value);
    const countryCode = parseString(_.get(value, 'countryCode'));
    const countryName = parseString(_.get(value, 'countryName'));
    const changedAt = parseDatetime(_.get(value, 'changed_at'));

    return {
      text,
      country_code: countryCode,
      country_name: countryName,
      changed_at: changedAt,
    };
  },

  getFormulaValue: (engineValue) => (engineValue.text === null ? '' : engineValue.text),
};

export default handler;
